import { safeDefine } from '../../registration/safe-define';
import { SliderFillElement } from '../../ui/slider/fill';

safeDefine(SliderFillElement);

declare global {
  interface HTMLElementTagNameMap {
    [SliderFillElement.tagName]: SliderFillElement;
  }
}
